<header class="flex header p-2">
  <h2>{{ 'COA_EditAccount_Title' | translateWF: 'Edit account' }}</h2>
  <p-button icon="pi pi-times" variant="text" (click)="onClose()" />
</header>

<section class="content">
  <!-- Fixed properties are shown, not hidden: the point is that the user can see WHY they cannot be
       changed, rather than wondering where the field went. -->
  <div class="grid-2 mb-4">
    <div class="form-box">
      <label>{{ 'COA_NewAccount_Number' | translateWF: 'Account number' }}</label>
      <span class="font-mono">{{ account.accountNumber }}</span>
    </div>
    <div class="form-box">
      <label>{{ 'COA_NewAccount_Parent' | translateWF: 'Parent account' }}</label>
      <span>{{ parentLabel() }}</span>
    </div>
    <div class="form-box">
      <label>{{ 'COA_NewAccount_Type' | translateWF: 'Account type' }}</label>
      <span>{{ typeLabel() }}</span>
    </div>
    <div class="form-box">
      <label>{{ 'COA_NewAccount_Currency' | translateWF: 'Currency' }}</label>
      <span>{{ currencyLabel() }}</span>
    </div>
    <div class="form-box span-2">
      <label>{{ 'COA_NewAccount_Subledger' | translateWF: 'Subledger type' }}</label>
      <span>{{ subledgerLabel() }}</span>
    </div>
  </div>

  <p-message severity="secondary" styleClass="w-full mb-4">
    <span class="text-sm">
      {{
        'COA_EditAccount_Locked_Hint'
          | translateWF: 'Number, type, currency and subledger are fixed once the account exists — postings already recorded depend on them. Create a new account instead.'
      }}
    </span>
  </p-message>

  <form [formGroup]="form" class="grid-2">
    <div class="form-box">
      <label ariaRequired="true">{{ 'COA_NewAccount_NameEn' | translateWF: 'Name (English)' }}</label>
      <input pInputText formControlName="nameEn" class="w-full" />
    </div>

    <div class="form-box">
      <label>{{ 'COA_NewAccount_NameEs' | translateWF: 'Name (Spanish)' }}</label>
      <input pInputText formControlName="nameEs" class="w-full" [placeholder]="'COA_NewAccount_NameEs_Hint' | translateWF: 'Defaults to the English name'" />
    </div>

    <div class="form-box span-2">
      <label [attr.ariaRequired]="isSubledger() ? true : null">{{ 'COA_NewAccount_PostingModules' | translateWF: 'Who may post here' }}</label>
      <p-multiSelect
        formControlName="postingModules"
        [options]="postingModuleOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        styleClass="w-full"
        [placeholder]="'COA_NewAccount_PostingModules_Ph' | translateWF: 'Any module (leave empty)'"
      />
      @if (isSubledger()) {
        <small class="text-surface-500">{{ 'COA_NewAccount_PostingModules_Sub' | translateWF: 'A subledger account must authorize at least one module.' }}</small>
      } @else {
        <small class="text-surface-500">
          {{
            'COA_NewAccount_PostingModules_Hint' | translateWF: 'Leave empty to allow any module. Pick modules to reserve this account to them — other screens will grey it out.'
          }}
        </small>
      }
    </div>
  </form>
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
  <p-button [label]="'Save' | translateWF: 'Save'" [disabled]="form.invalid" (click)="onSave()" />
</footer>
